import React from "react";
import { Navigate } from "react-router-dom";
import AccessDenied from "./components/AccessDenied";

const DEFAULT_ALLOWED_EMAILS = ["ankit@logicsofts.com", "suny@logicsofts.com"];

export const EmailRestrictedRoute = ({ children, allowedEmails }) => {
  const authToken = localStorage.getItem("auth_token");
  const authEmail = (localStorage.getItem("auth_email") || "").toLowerCase();

  if (!authToken) {
    return <Navigate to="/login" replace />;
  }

  const emails = allowedEmails || DEFAULT_ALLOWED_EMAILS;
  if (emails.includes(authEmail)) {
    return children;
  }

  return <AccessDenied />;
};
